<template>
  <div class="edit">
    <CloseModalBtn :closeModal="closeModal" />
    <h5>
      {{
        create
          ? localStorage.translations.pages.personnel_department[
              'employees_group-dialog-additional_project'
            ].title_add
          : localStorage.translations.pages.personnel_department[
              'employees_group-dialog-additional_project'
            ].title_edit
      }}
    </h5>
    <v-form
      ref="form"
      lazy-validation
      v-model="valid"
      @submit.prevent="onCreateOrUpdatePeriod"
      class="d-grid gap-5"
    >
      <BaseInput
        type="select"
        :label="
          localStorage.translations.pages.personnel_department[
            'employees_group-dialog-additional_project-labels'
          ].employee
        "
        v-model="employee_id"
        :items="employeeGroupShow.employees"
        append-icon="fas fa-angle-down"
        :item-value="(i) => i.id"
        :item-text="(i) => (i.user ? i.user.first_name + ' ' + i.user.last_name : null)"
        :rules="['required']"
      />
      <div class="form_row">
        <BaseInput
          type="date-picker"
          :label="
            localStorage.translations.pages.personnel_department[
              'employees_group-dialog-additional_project-labels'
            ].date_start
          "
          v-model="start_date"
          :rules="['required']"
        />
        <BaseInput
          type="date-picker"
          :label="
            localStorage.translations.pages.personnel_department[
              'employees_group-dialog-additional_project-labels'
            ].date_end
          "
          v-model="end_date"
          :rules="['required']"
        />
      </div>
      <BaseInput
        type="select"
        :label="
          localStorage.translations.pages.personnel_department[
            'employees_group-dialog-additional_project-labels'
          ].select_project
        "
        :disabled="!extraWorkGrid.length"
        v-model="project_id"
        :items="extraWorkGrid"
        append-icon="fas fa-angle-down"
        :item-value="(i) => i.id"
        :item-text="(i) => i.name"
        :rules="['required']"
        :placeholder="
          create
            ? localStorage.translations.pages.common['text'].not_selected
            : item.project_work_type.project.name
        "
      />
      <BaseInput
        type="select"
        :label="
          localStorage.translations.pages.personnel_department[
            'employees_group-dialog-additional_project-labels'
          ].select_work_type
        "
        :disabled="!project_id || !extraWorkGrid.length"
        v-model="worksPick"
        :items="extraWorkGridProject"
        append-icon="fas fa-angle-down"
        :item-value="(i) => i.project_work_type_id"
        :item-text="(i) => i.name"
        :placeholder="
          create
            ? localStorage.translations.pages.common['text'].not_selected
            : item.project_work_type.work_type.name
        "
        :rules="['required']"
        :multiple="create"
        :chips="create"
      />
      <div class="container_btn">
        <BaseButton
          type="submit"
          :text="
            localStorage.translations.pages.personnel_department[
              'employees_group-dialog-additional_project-buttons'
            ].save
          "
          default_icon="button-save"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import CloseModalBtn from 'components/CloseModalBtn'
import BaseInput from 'components/base/BaseInput'

export default {
  name: 'EmployeesGroupSelectModalWorkTypeExtraForm',
  components: { BaseInput, CloseModalBtn },
  props: ['id', 'dialog', 'closeModal', 'create', 'item'],

  data() {
    return {
      menu1: false,
      menu2: false,
      valid: true,
      start_date: null,
      end_date: null,
      dateStartFormatted: null,
      dateEndFormatted: null,
      name: '',
      employee_id: [],
      project_id: null,
      projectsReady: [],
      worksPick: null,
      extraWorkGrid: [],
      extraWorkGridProject: [],
      periodShow: [],
    }
  },
  created() {
    if (!this.create) {
      this.onWorkClientProjectsWorkTypePeriodShow(this.id).then((resp) => {
        this.periodShow = resp.data.data
        this.project_id = resp.data.data.project_work_type.project_id
        this.worksPick = []
        this.worksPick.push(resp.data.data.project_work_type.work_type.id)
      })
    }
    this.onWorkClientProjectGrid_filter({
      limit: 0,
      page: 1,
      filter: {status: 'pending,in_progress'},
    })
  },
  mounted() {},
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('employeeGroup', ['employeeGroupShow']),
    ...mapGetters('workClientProject', [
      'workClientProjectExtraWorkGrid',
      'workClientProjectGrid_filter',
    ]),
    apiDomain() {
      return this.$store.state.apiDomain
    },
    computedDateFormatted() {
      return $formatDate(this.start_date)
      return $formatDate(this.end_date)
    },
    projectInWork() {
      return this.workClientProjectGrid_filter.map((d) => d.id)
    },
  },
  watch: {
    employee_id() {
      if (this.start_date && this.end_date) {
        this.downloadData()
      }
    },
    start_date(val) {
      this.dateStartFormatted = this.$formatDate(this.start_date)
      if (this.end_date) {
        this.checkDate()
      }
    },
    end_date(val) {
      this.dateEndFormatted = this.$formatDate(this.end_date)
      this.checkDate()
    },
    project_id() {
      let temp = this.extraWorkGrid.find((i) => i.id == this.project_id)
      this.extraWorkGridProject = temp ? temp.work_types : []
    },
    periodShow() {
      this.employee_id = this.periodShow.employees[0].id
      this.start_date = this.periodShow.start_date
      this.end_date = this.periodShow.end_date
      // this.project_id = this.periodShow.project_work_type.work_type_category.id
      // this.worksPick = this.periodShow.project_work_type.work_type.id
    },
  },
  methods: {
    ...mapActions('workClientProject', [
      'onWorkClientProjectExtraWorkGrid',
      'onWorkClientProjectGrid_filter',
    ]),
    ...mapActions('employeeGroup', ['onEmployeeGroupWorkPeriods']),
    ...mapActions('workClientProjectsWorkTypePeriod', [
      'onWorkClientProjectsWorkTypePeriodCreate',
      'onWorkClientProjectsWorkTypePeriodCreateMultiple',
      'onWorkClientProjectsWorkTypePeriodUpdate',
      'onWorkClientProjectsWorkTypePeriodShow',
    ]),
    validate() {
      this.$refs.form.validate()
    },
    downloadData() {
      this.onWorkClientProjectExtraWorkGrid({
        employee_id: this.employee_id,
        start_date: this.start_date,
        end_date: this.end_date,
      }).then((resp) => {
        this.extraWorkGrid = []
        console.log(resp.data.data)
        for (let i in resp.data.data) {
          if (this.projectInWork.includes(resp.data.data[i].id)) {
            this.extraWorkGrid.push(resp.data.data[i])
          }
        }
        let temp = this.extraWorkGrid.find((i) => i.id == this.project_id)
        this.extraWorkGridProject = temp ? temp.work_types : []
      })
    },
    async checkDate() {
      if (this.start_date && this.end_date) {
        if (this.end_date < this.start_date) {
          let start = this.start_date
          let end = this.end_date
          this.start_date = end
          this.end_date = start
          this.downloadData()
        } else this.downloadData()
      }
    },
    async onCreateOrUpdatePeriod() {
      await this.validate()
      if (this.valid) {
        if (this.create) {
          let data = {
            id: this.id ? this.id : null,
            project_work_type_ids: this.worksPick,
            start_date: this.start_date,
            end_date: this.end_date,
            employees: [this.employee_id],
            is_extra: 1,
          }
          return new Promise((resolve, reject) => {
            this.onWorkClientProjectsWorkTypePeriodCreateMultiple(data)
              .then((resp) => {
                resolve(resp)
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'uspeshno-dobavlen'
                      ],
                    IsError: false,
                  },
                  { root: true },
                )
                this.onEmployeeGroupWorkPeriods({
                  group_id: this.$route.params.id,
                  is_extra: 1,
                })
                this.closeModal()
              })
              .catch((err) => {
                if (err.response.data.errors) {
                  this.$store.dispatch(
                    'popup/onMessage',
                    {
                      message: this.localStorage.translations.pages.common.notifications['oshibka'],
                      IsError: true,
                    },
                    { root: true },
                  )
                }
              })
          })
        } else {
          let data = {
            id: this.id ? this.id : null,
            project_work_type_id: this.worksPick,
            start_date: this.start_date,
            end_date: this.end_date,
            employees: [this.employee_id],
            is_extra: 1,
          }
          return new Promise((resolve, reject) => {
            this.onWorkClientProjectsWorkTypePeriodUpdate(data)
              .then((resp) => {
                resolve(resp)
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'izmeneniya-uspeshno-sohraneny'
                      ],
                    IsError: false,
                  },
                  { root: true },
                )
                this.onEmployeeGroupWorkPeriods({
                  group_id: this.$route.params.id,
                  is_extra: 1,
                })
                this.closeModal()
              })
              .catch((err) => {
                if (err.response.data.errors) {
                  this.$store.dispatch(
                    'popup/onMessage',
                    {
                      message: this.localStorage.translations.pages.common.notifications['oshibka'],
                      IsError: true,
                    },
                    { root: true },
                  )
                }
              })
          })
        }
      }
    },
    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
}
</script>

<style lang="scss" scoped>
.edit:deep() {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 60px;
  position: relative;
  .close {
    padding: 16px;
  }
  h5 {
    text-align: center;
    margin-bottom: 50px;
  }
  form {
    text-align: left;
    display: grid;
    grid-column-gap: 30px;
    grid-row-gap: 10px;
    .form_row {
      display: flex;
      justify-content: space-between;
      column-gap: 20px;
    }
    label {
      line-height: 26px;
      color: #52525f;
    }
    .v-text-field {
      padding-top: 0px;
      margin-top: 0px;
      fieldset {
        border: 1px solid #b4b4b4;
        border-radius: 4px;
      }
      .theme--light.v-icon {
        color: #b4b4b4;
      }
    }
    .container_btn {
      display: grid;
      justify-content: center;
      margin-top: 30px;
    }
    .v-input--selection-controls {
      margin-top: 0;
    }
  }
}
</style>